export enum TelemetryErrorTagEnum {
  JAVASCRIPT = '',
  UNKNOWN = '',
  ENDPOINT = 'Endpoint',
}
